import { Module } from 'vuex'
import { AgentOfferState, AppState } from '@bd/agent/types'

import { state } from './state'
import { actions } from './actions'
import { mutations } from './mutations'

const offers: Module<AgentOfferState, AppState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default offers
